import { render, staticRenderFns } from "./SubZone.vue?vue&type=template&id=7321839d"
import script from "./SubZone.vue?vue&type=script&lang=js"
export * from "./SubZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports